import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import reactCSS from 'reactcss';
import { db } from '../firebase';
import { BlockPicker, ChromePicker } from 'react-color';
import Modal from './global/modal';

const byPropKey = (propertyName, value) => () => ({
  [propertyName]: value,
});

class ExportFormColour extends Component {
  constructor(props) {
    super(props);

    this.state = {
      saving: false,
      firstInstance: true,
      displayPrimaryColourPicker: false,
      colour: this.props.hex,
      showDeleteModal: false,
    };
  }

  updateExportColour(colour) {
    this.props.updateColour(`ff${colour.substring(1)}`, this.props.index);
  }

  render() {
    const pickerStyles = reactCSS({
      default: {
        color: {
          width: '36px',
          height: '14px',
          borderRadius: '2px',
          // background: `rgba(${ this.state.color.r }, ${ this.state.color.g }, ${ this.state.color.b }, ${ this.state.color.a })`,
        },
        swatch: {
          padding: '5px',
          background: '#fff',
          borderRadius: '1px',
          boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
          display: 'inline-block',
          cursor: 'pointer',
        },
        popover: {
          position: 'absolute',
          zIndex: '2',
        },
        cover: {
          position: 'fixed',
          top: '0px',
          right: '0px',
          bottom: '0px',
          left: '0px',
        },
        primarycolorinput: {
          borderColor: this.state.colour.includes('#') ? this.state.colour : `#${this.state.colour}`,
          borderWidth: '2px',
        },
      },
    });

    return (
      <form key={this.props.n} action='/' className='pv3' onSubmit={this.handleSubmit}>
        <p>
          <strong>{this.props.title}</strong>
        </p>
        <div className='flex justify-start'>
          <div className='w-100'>
            <label className='db'>Colour</label>
            <input
              required
              style={pickerStyles.primarycolorinput}
              ref={(input) => (this.exportColour = input)}
              type='text'
              className='w-100'
              onClick={(e) => {
                this.setState({ displayPrimaryColourPicker: true });
              }}
              value={this.state.colour}
            />
            {this.state.displayPrimaryColourPicker ? (
              <div style={pickerStyles.popover}>
                <div
                  style={pickerStyles.cover}
                  onClick={(e) => {
                    this.setState({ displayPrimaryColourPicker: false });
                  }}
                />
                <ChromePicker
                  color={this.state.colour}
                  onChange={(color) => {
                    this.setState(byPropKey('colour', color.hex));
                    this.updateExportColour(color.hex);
                  }}
                />
              </div>
            ) : null}
          </div>
        </div>

        <span className={this.state.saving ? 'loading-spinner' : !this.state.firstInstance ? 'loading-done' : ''} />
      </form>
    );
  }
}

//
export default ExportFormColour;
